import React from "react";
import { Box, Typography } from "@mui/material";
import { POKIES_SYMBOL_IMAGES } from "../../../../../static/Constants";
import { getSymbolById } from "./threeSlotConfig";

/**
 * 3-Slot Pokies Symbol Image Renderer
 * Renders the high-definition 3D PNG Pokies symbol with golden borders and glowing animation.
 */
export const ThreeSlotSymbolIcon = ({ symbol, size = "md", isWinning = false }) => {
  if (!symbol) return null;

  const isSmall = size === "sm";
  const isLarge = size === "lg";

  const containerSize = isSmall ? 44 : isLarge ? 84 : 64;
  const imageSize = isSmall ? 34 : isLarge ? 68 : 52;

  // Resolve symbol image
  let symbolImg = symbol.image;
  if (!symbolImg && symbol.id) {
    symbolImg =
      POKIES_SYMBOL_IMAGES[symbol.id] ||
      POKIES_SYMBOL_IMAGES[
        symbol.id === "gold_nugget"
          ? "goldNugget"
          : symbol.id === "jackpot_crown"
          ? "jackpotCrown"
          : symbol.id === "kundu_drum"
          ? "kunduDrum"
          : symbol.id === "kumul_bird"
          ? "kumulBird"
          : symbol.id === "pol"
          ? "polCoin"
          : symbol.id === "btc"
          ? "btcCoin"
          : symbol.id === "lucky_7"
          ? "lucky7"
          : symbol.id === "jackpot_orb"
          ? "jackpotOrb"
          : symbol.id
      ] ||
      getSymbolById(symbol.id)?.image;
  }

  return (
    <Box
      sx={{
        width: containerSize,
        height: containerSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        borderRadius: "12px",
        background: "radial-gradient(circle at 50% 35%, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.95) 100%)",
        border: isWinning
          ? "2px solid #facc15"
          : "1.5px solid rgba(234, 179, 8, 0.35)",
        boxShadow: isWinning
          ? "0 0 16px rgba(250, 204, 21, 0.9), inset 0 0 8px rgba(250, 204, 21, 0.5)"
          : "inset 0 1px 3px rgba(255, 255, 255, 0.1), 0 2px 6px rgba(0,0,0,0.5)",
        animation: isWinning ? "winningPulse 0.8s ease-in-out infinite alternate" : "none",
        "@keyframes winningPulse": {
          "0%": { transform: "scale(1)", filter: "drop-shadow(0 0 4px rgba(250, 204, 21, 0.6))" },
          "100%": { transform: "scale(1.08)", filter: "drop-shadow(0 0 14px rgba(250, 204, 21, 1))" },
        },
      }}
    >
      {symbolImg ? (
        <Box
          component="img"
          src={symbolImg}
          alt={symbol.label || symbol.id || "Symbol"}
          sx={{
            width: imageSize,
            height: imageSize,
            objectFit: "contain",
            filter: "drop-shadow(0 2px 5px rgba(0, 0, 0, 0.6))",
            userSelect: "none",
            pointerEvents: "none",
          }}
        />
      ) : (
        <Typography sx={{ fontSize: isSmall ? "1.2rem" : isLarge ? "2.2rem" : "1.7rem" }}>
          {symbol.symbolText || symbol.iconText || "🎰"}
        </Typography>
      )}
    </Box>
  );
};

export default ThreeSlotSymbolIcon;
